<template>
    <Dropdown class="ly-dropdown" v-if="isDisplay">
        <Button type="primary" ghost :icon="attrs.icon">
            {{ attrs.title }}<Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
            <template v-for="el in attrs.children">
                <DropdownItem>
                    <ly-hoc :attrs="el" :row="page"></ly-hoc>
                </DropdownItem>
            </template>
        </DropdownMenu>
    </Dropdown>
</template>
<script>
/**
 * 下拉菜单
 * 主要是存放操作按钮的，容器组件
 */
import CompEventMixin from '@/utils/compEvent.mixin'
import CompDisplayMixin from '@/utils/compDisplay.mixin'
export default {
    name: 'LyDropdown',
    mixins: [CompEventMixin, CompDisplayMixin],
    props: {
        attrs: {
            type: Object,
            default: _ => new Object()
        }
    }
}
</script>
<style>
.ly-dropdown .ivu-dropdown-item {
    padding: 0;
}

.ly-dropdown .ivu-dropdown-item .ivu-btn {
    border-color: #fff;
}
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/dropdown/src/index.vue